module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/pagination/pagination.component.scss
// module id = ./src/app/modules/common-module/components/pagination/pagination.component.scss
// module chunks = 9